import React from "react";
import {strings} from "../../../strings/strings";
import moment from "moment";
import {ScenarioHeader} from "../../../components/Scenario/Header";


export const MtplScenarioHeader = () => {

    const description = moment().isBetween('2021-03-15', '2021-03-31')
        ? 'Купуючи онлайн автоцивілку від ARX, ви автоматично берете участь у розіграші автошин на своє авто. \nАкція діє з 15.03.2021 - 31.03.2021'
        : strings.scenarioHeaderDescription


    return <ScenarioHeader title={strings.scenarioHeaderName} description={description} />
};